import React, { useEffect, useRef } from "react";
import styled, {keyframes} from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  flex: 1;
`

const animateRight = keyframes`
  from { transform: translateX(-33.33333%); }
  to   { transform: translateX(0); }
`;

const animateLeft = keyframes`
  from { transform: translateX(-33.33333%); }
  to   { transform: translateX(-66.66666%); }
`;

const Container = styled.div<{
    height: number;
    itemscount: number;
    animationtime: number;
    direction: "reverse"|"forward";
}>`
    display: inline-flex;
    white-space: nowrap;
    transform: translateX(${props => props.direction === "reverse" ? "-66.666666%" : "-33.333333%"});
    animation: ${props => props.direction === "reverse" ? animateLeft : animateRight} ${props => props.animationtime * props.itemscount}s linear infinite;
    will-change: transform;
    position: relative;
    height: 100%;
    height: ${props => props.height}px;
    max-width: 40000px;
`

const Cover = styled.img`
    height: 100%;
    margin: 0px 8px;
    border-radius: 4px;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.25);
    position: relative;
    
`

export default function MagazinScroller({
    imageURLs,
    animationTime = 1,
    direction = "forward",
    height=null,
}: {
    height?: number;
    imageURLs: string[];
    animationTime?: number,
    direction?: "forward"|"reverse"
}) {

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // window.requestAnimationFrame(() => {
    //   if (ref.current) {
    //     ref.current.style.display = "none"
    //     const x = ref.current.offsetHeight
    //     ref.current.style.marginBottom = "1px"
    //     console.log(x)
    //     ref.current.style.display = ""
    //   }
    // })
    //ref.current()
  }, [])

  const repeated = imageURLs.concat(imageURLs).concat(imageURLs).concat(imageURLs).concat(imageURLs).concat(imageURLs).concat(imageURLs).concat(imageURLs)

  return (
    <Wrapper ref={ref}>
        <Container 
            height={height}
            animationtime={animationTime} 
            itemscount={imageURLs.length}
            direction={direction}
        >
            {repeated.concat(repeated).concat(repeated).map((url, key) => 
                <Cover key={key} src={url}></Cover>
            )}
        </Container>
    </Wrapper>
  );
}
